export default "__VITE_ASSET__CQ84UJk1__"